import t from "../services/GetTranslationValue"

export const getMaxBetText = (translations, maxBet) => {
  if (maxBet.includes('bonuksesta')) {
    const value =  maxBet.substr(0, maxBet.indexOf('%'));
    const translate = t.get(translations, 'bonus-value-maxbet');

    return value + '%' + ' ' + translate;
  }
  return maxBet + t.get(translations, 'currency');
}